import React, { memo, useMemo } from "react";
import { Icon } from '../../components';
import { Profile as ProfileIcon } from '../../icons'
import { useMfwThemeProvider } from "myfitworld-utils";


const Profile = () => {
  const strokeColor = useMfwThemeProvider().mfwMuiWebTheme.palette.text.primary;

  const styes = useMemo(() => {
    return { stroke: strokeColor, fill: 'none' }
  }, [strokeColor])

  return (
    <Icon icon={ProfileIcon} style={styes} />
  );
};

export default memo(Profile);
